const oktaDomain = process.env.REACT_APP_OKTA_DOMAIN;
const oktaAuthorizationServerId = process.env.REACT_APP_OKTA_AUTH_SERVER_ID;
const oktaClientId = process.env.REACT_APP_OKTA_CLIENT_ID;

const oktaAuthConfig = {
	issuer: `https://${oktaDomain}/oauth2/${oktaAuthorizationServerId}`,
	clientId: oktaClientId,
	redirectUri: `${window.location.origin}/auth/default/callback`,
	tokenManager: {
		storage: 'sessionStorage'
	},
	// scopes: ['openid', 'profile', 'okta.users.read.self'],
	pkce: true,
};

export default oktaAuthConfig;

